module.exports = __webpack_public_path__ + "img/role2.461acad1.png";